<template>
  <Swiper
  :modules="[SwiperPagination]"
  :slides-per-view="1"
  :space-between="16"
  :pagination="{
    clickable: true,
  }"
  >
    <SwiperSlide
        :key="1"
        class="px-4 sm:px-10"
      >
      <img
        class="mx-auto w-full"
        src="~/assets/images/Te/TeLp/Branded/Index/reaction-slide-1.webp"
        alt="目標達成までの、具体的なステップを丁寧に教えていただき、スクール卒業後にどうするかもイメージ湧きました。（売込みもなかった笑）"
        width="343"
        height="190"
        loading="lazy"
      />
    </SwiperSlide>
    <SwiperSlide
        :key="2"
        class="px-4 sm:px-10"
      >
      <img
        class="mx-auto w-full"
        src="~/assets/images/Te/TeLp/Branded/Index/reaction-slide-2.webp"
        alt="説明がすごくわかりやすくて復習になった。こんな感じでレッスンできるなら続けられそう！"
        width="343"
        height="190"
        loading="lazy"
      />
    </SwiperSlide>
    <SwiperSlide
        :key="3"
        class="px-4 sm:px-10"
      >
      <img
        class="mx-auto w-full"
        src="~/assets/images/Te/TeLp/Branded/Index/reaction-slide-3.webp"
        alt="PC購入とかWebカメラ不具合とか相談に乗ってもらえてとても助かった。"
        width="343"
        height="190"
        loading="lazy"
      />
    </SwiperSlide>
    <SwiperSlide
        :key="4"
        class="px-4 sm:px-10"
      >
      <img
        class="mx-auto w-full"
        src="~/assets/images/Te/TeLp/Branded/Index/reaction-slide-4.webp"
        alt="担当していただいた講師の方が優しく詳しく説明していただけました！"
        width="343"
        height="190"
        loading="lazy"
      />
    </SwiperSlide>
  </Swiper>
</template>

<script setup lang="ts">
</script>

<style scoped>
@import url('~/assets/css/Te/TeCommon/TeCommonSwiper.css');
</style>